import { render, staticRenderFns } from "./GroupsPage.vue?vue&type=template&id=2a0467bd&scoped=true"
import script from "./GroupsPage.vue?vue&type=script&lang=js"
export * from "./GroupsPage.vue?vue&type=script&lang=js"
import style0 from "./GroupsPage.vue?vue&type=style&index=0&id=2a0467bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0467bd",
  null
  
)

export default component.exports